module.exports = "/static/assets/a9f68e6391e803ca55d49bdbb536a946.png";